export default {
  hzmbH: {
    title: {
      ownerInfo: "車主資料",
      canceklInfo: "取消說明",
    },
    label: {
      commercialCode: "商業登記編號",
      mobile: "聯絡方式",
      registrationNo: "車輛的註冊編號",
      mainlandRegistrationNo: "內地登記車牌編號",
      identityType: "證件類別",
      identityNo: "澳門居民身份證編號",
      nameCn: "中文姓名",
      nameEn: "外文姓名",
      companyIdentityType: "商業登記類型",
      companyBrNo: "商業登記編號",
      companyBrNameCn: "商業登記名稱（中文）",
      companyBrNameEn: "商業登記名稱（外文）",
      macauMobile: "本澳流動電話",
      hongKongMobile: "香港聯絡電話",
      otherMobile: "其他聯絡電話",
      mainlandPhone: "內地聯絡電話",
      mainlandEmail: "內地電郵地址",
      macauAddress: "澳門聯絡地址",
      hongKongAddress: "香港聯絡地址",
      mainlandDrivingLicenseNo: "內地駕照編號",
      mainlandDrivingPermitNo: "內地駕照許可檔案編號",
      applicationNo: "申請編號：",
      cancelReason: "取消原因",
      macaoDrivingLicenseType: "澳門駕駛文件類別",
      macaoDrivingLicenseNo: "澳門駕駛文件編號",
    },
    message: {
      mustChooseOne1: "（請在“內地聯絡電話”或“內地電郵地址”中請選擇一個填寫）",
      mustChooseOne2: "內地聯絡電話、內地電郵地址必選其一",
      deleteConfirm: "是否確認刪除？",
      deleteSuccess: "刪除成功",
      handleSuccess: "辦理成功",
    },
    terms_hzmbH_first:
      "<p>" +
      "  1. 應遵事項" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>每一申請均可配備不多於三名指定駕駛員，指定駕駛員須持有有效澳門居民身份證及由澳門當局發出的證明其具相關駕駛資格的牌證。</li>" +
      "  <li>獲發許可後，如需更換使用許可的車輛（下稱“許可車輛＂）或車輛註冊號碼必須致函向交通事務局提出註銷舊登記後重新申請。</li>" +
      "  <li>許可不得轉讓，如車輛所有人在許可有效期內更改為另一所有人（許可持有人不再是許可車輛的所有人），有關許可將會被取消。</li>" +
      "  <li>許可車輛須為許可持有人在澳門註冊登記為輕型貨車、重型貨車、客貨車、拖頭或拖架；許可持有人/公司亦必須確保配額車輛於行駛港珠澳大橋時持有三地有效車輛強制保險。</li>" +
      "  <li>許可車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，許可車輛及駕駛員在大橋主橋行駛時，須遵守內地法例及內地對來往港澳但不入境珠海車輛的規定。</li>" +
      "  <li>具備有效許可、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）、澳門海關發出的有效「車輛邊境通行證」和「車輛通關電子標籤」（RFID），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的許可車輛，並在完成往港預約配額後，方可由持有有效香港商用車輛駕駛執照的指定駕駛員駕駛車輛經港珠澳大橋於指定日子前往香港國際機場物流設施運作，任何人須自行對因其自身、內地或香港的原因導致其許可車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
      "  <li>許可持有人、指定駕駛員或許可車輛如違反申領許可及港澳有關牌證的條款，其有關許可及牌證可被取消，其牌證及許可申請亦將不予受理。如許可、牌證或入境資格被取消，相應的許可及牌證亦可被取消。</li>" +
      "  <li>如內地根據內地規定取消有關車輛或申請人的入境資格，其相關牌證及許可可被取消，其牌證及許可申請亦將不予受理。</li>" +
      "  <li>如發現許可持有人或指定駕駛員曾利用許可車輛進行走私、運送他人偷越邊境、非法營運（包括“白牌車”）、違規攜帶禁止或限制進出境物品、未申報應實施檢驗檢疫的行李或貨物等違法活動，該車輛相應的許可可被取消。</li>" +
      "  <li>申請人及許可持有人所填寫及提交的一切資料均須屬實，並無虛訛，否則其申請將不予受理或其許可可被取消。</li>" +
      "  <li>如許可車輛無正當理由逾期離澳，自離港或查實確認之日起計30日後將被暫停預約。</li>" +
      "  <li>如發現許可車輛曾超出通行區、通行條件或並非由指定駕駛員駕駛，其許可可被取消。</li>" +
      "  <li>如許可持有人或行為人未有遵從港澳政府訂定的預約限制規定，自查實確認之日起計30日後，將執行以下措施:</li>" +
      "  <div>(a)一次違規，將被警告；</div>" +
      "  <div>(b)兩次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被暫停一個月；</div>" +
      "  <div>(c)三次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被暫停兩個月；</div>" +
      "  <div>(d)四次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被暫停六個月；</div>" +
      "  <div>(e)五次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被永久取消。</div>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  2. 個人資料的保護" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
      "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
      "  <li>申請人提供的所有個人資料，將按照澳門特別行政區第 8/2005 號法律《個人資料保護法》的規定進行處理，本局於審查文件時遇有疑問，有關資料可能會送交予有權 限機構作驗證或查詢。申請人依法享有資訊權、查閱權、更正權及反對權，在行使有關權利時，必須以書面方式向本局提出。申請人向本局提交任何個人資料前，必須已獲得 資料當事人之同意及向其提供第 8/2005 號法律《個人資料保護法》第 10 條第 1 款規定的資訊。</li>" +
      "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。而為處理有關申請，交通事務局與相關行政當局（包括內地、香港、澳門的相關行政當局）可根據第 8/2005 號法律《個人資料保護法》的規定，以包括資料互聯在內的 任何方式，互相提供、交換、確認及使用涉及利害關係人的車輛、車主及駕駛員等的個人資料。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  3. 免責聲明" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
      "  <li>本網站會適時為本系統項目之監管運作優化進行使用規章更新，為確保所得訊息及時，請留意本網站的最新公告。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  4. 私隱條款" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>申請者及使用者於本系統所輸入之個人資料只會用於本系統及列印在倘有的電子收據上。</li>" +
      "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。(SSL)。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  5. 使用條款的改變" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  6. 聯絡方法" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
      "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
      "  <li>交通事務專線：(853) 8866 6363</li>" +
      "  <li>電郵：info@dsat.gov.mo</li>" +
      "</ul>",
    terms_hzmbH_booking:
      "<p>" +
      "  1. 預約規則" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>以先到先得方式預約(最早可提前30天或最遲於預約日當天的12:00前預約)，額滿後停止當天預約申請，倘有預約配額被取消，將重新於平台上發放供預約；</li>" +
      "  <li>取消預約必須最遲於預約當天的12:00前取消，每一車輛每月最多可取消預約兩次；</li>" +
      "  <li>車輛每次入境香港需要預約一次，系統允許車輛同一天多次預約；</li>" +
      "  <li>被發現沒有預約往港或預約當日沒有使用預約配額往港均視為違規，自查實確認之日起計30日後，將被違規處理。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  2. 違規處理" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <div>(a)一次違規，將被警告；</div>" +
      "  <div>(b)兩次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被暫停一個月；</div>" +
      "  <div>(c)三次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被暫停兩個月；</div>" +
      "  <div>(d)四次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被暫停六個月；</div>" +
      "  <div>(e)五次違規，有關司機/公司或團體旗下全部貨車的已預約資格會被永久取消。</div>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  3. 個人資料的保護" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
      "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
      "  <li>申請人提供的所有個人資料，將按照澳門特別行政區第 8/2005 號法律《個人資料保護法》的規定進行處理，本局於審查文件時遇有疑問，有關資料可能會送交予有權 限機構作驗證或查詢。申請人依法享有資訊權、查閱權、更正權及反對權，在行使有關權利時，必須以書面方式向本局提出。申請人向本局提交任何個人資料前，必須已獲得 資料當事人之同意及向其提供第 8/2005 號法律《個人資料保護法》第 10 條第 1 款規定的資訊。</li>" +
      "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。而為處理有關申請，交通事務局與相關行政當局（包括內地、香港、澳門的相關行政當局）可根據第 8/2005 號法律《個人資料保護法》的規定，以包括資料互聯在內的 任何方式，互相提供、交換、確認及使用涉及利害關係人的車輛、車主及駕駛員等的個人資料。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  4. 免責聲明" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  5. 私隱條款" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>申請者及使用者於本系統所輸入之個人資料只會用於本系統及列印在倘有的電子收據上。</li>" +
      "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  6. 使用條款的改變" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  7. 聯絡方法" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
      "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
      "  <li>交通事務專線：(853) 8866 6363</li>" +
      "  <li>電郵：info@dsat.gov.mo</li>" +
      "</ul>",
  },
};
